import Vue from 'vue'

export var appConfig = {
  api_path: './adm/',
  file_path: 'http://www.dygmgs.com/images/'
}

export function getGuid(){
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  })
}

export function isNullOrEmpty(val){
  return val == null || (typeof(val) == "string" && val.replace(/(^\s*)|(\s*$)/g, '') == '');
}

export function fmtTime(val){
  return val.replace("T", " ").substr(0,19);
}


// WEBPACK FOOTER //
// ./src/api/utils.js